import { z } from 'zod';

export const PoliciesSchema = z.object({
    policy: z
        .object({
            policyId: z.number().min(1, { message: 'Required' }),
            requiresConsent: z.boolean().default(true),
        })
        .optional()
        .nullable(),
});
